/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technologies_SourcesInputs */

const en_us2_technologies_sources = /** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources`)
};

const es_es2_technologies_sources = /** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes`)
};

const ru_technologies_sources = /** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Источники`)
};

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const id_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const ms_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const da_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const de_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const es_mx2_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const fil_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const fr_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const it_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const hu_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const nl_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const no_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const pl_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const pt_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const pt_br2_technologies_sources = pt_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const ro_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const fi_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const sv_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const vi_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const tr_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const cs_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const bg_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const uk_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const ar_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const hi_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const th_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const ja_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const zh_cn2_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const zh_hant1_technologies_sources = en_us2_technologies_sources;

/** @type {(inputs: Technologies_SourcesInputs) => LocalizedString} */
const ko_technologies_sources = en_us2_technologies_sources;

/**
* | output |
* | --- |
* | "Sources" |
*
* @param {Technologies_SourcesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_sources = /** @type {((inputs?: Technologies_SourcesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_SourcesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_sources(inputs)
	if (locale === "ms") return ms_technologies_sources(inputs)
	if (locale === "da") return da_technologies_sources(inputs)
	if (locale === "de") return de_technologies_sources(inputs)
	if (locale === "en-US") return en_us2_technologies_sources(inputs)
	if (locale === "es-ES") return es_es2_technologies_sources(inputs)
	if (locale === "es-MX") return es_mx2_technologies_sources(inputs)
	if (locale === "fil") return fil_technologies_sources(inputs)
	if (locale === "fr") return fr_technologies_sources(inputs)
	if (locale === "it") return it_technologies_sources(inputs)
	if (locale === "hu") return hu_technologies_sources(inputs)
	if (locale === "nl") return nl_technologies_sources(inputs)
	if (locale === "no") return no_technologies_sources(inputs)
	if (locale === "pl") return pl_technologies_sources(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_sources(inputs)
	if (locale === "pt") return pt_technologies_sources(inputs)
	if (locale === "ro") return ro_technologies_sources(inputs)
	if (locale === "fi") return fi_technologies_sources(inputs)
	if (locale === "sv") return sv_technologies_sources(inputs)
	if (locale === "vi") return vi_technologies_sources(inputs)
	if (locale === "tr") return tr_technologies_sources(inputs)
	if (locale === "cs") return cs_technologies_sources(inputs)
	if (locale === "bg") return bg_technologies_sources(inputs)
	if (locale === "ru") return ru_technologies_sources(inputs)
	if (locale === "uk") return uk_technologies_sources(inputs)
	if (locale === "ar") return ar_technologies_sources(inputs)
	if (locale === "hi") return hi_technologies_sources(inputs)
	if (locale === "th") return th_technologies_sources(inputs)
	if (locale === "ja") return ja_technologies_sources(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_sources(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_sources(inputs)
	return ko_technologies_sources(inputs)
});
export { technologies_sources as "technologies.sources" }